import Blog_50_6_container from "./container/Blog_50_6_container";
export default Blog_50_6_container;
